module.exports = __webpack_public_path__ + "img/Background-Framed-Tiles-no-text-jpg.e7b1b9ec.webp";